var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 116,
    viewBox: "0 0 136 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.9 78.4998C123.164 78.4998 125 76.6642 125 74.3998C125 72.1354 123.164 70.2998 120.9 70.2998C118.636 70.2998 116.8 72.1354 116.8 74.3998C116.8 76.6642 118.636 78.4998 120.9 78.4998Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.026 89.9394C114.573 89.9394 115.826 88.6858 115.826 87.1394C115.826 85.593 114.573 84.3394 113.026 84.3394C111.48 84.3394 110.226 85.593 110.226 87.1394C110.226 88.6858 111.48 89.9394 113.026 89.9394Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 21.4999C23.8464 21.4999 25.1 20.2463 25.1 18.6999C25.1 17.1535 23.8464 15.8999 22.3 15.8999C20.7536 15.8999 19.5 17.1535 19.5 18.6999C19.5 20.2463 20.7536 21.4999 22.3 21.4999Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 75.5001C8.07188 75.5001 10.4 73.172 10.4 70.3001C10.4 67.4282 8.07188 65.1001 5.2 65.1001C2.32812 65.1001 0 67.4282 0 70.3001C0 73.172 2.32812 75.5001 5.2 75.5001Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 101.6C96.35 101.6 119.05 78.9 119.05 50.8C119.05 22.7 96.35 0 68.35 0C40.35 0 17.65 22.7 17.65 50.8C17.65 78.9 40.35 101.6 68.35 101.6Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7938 7.63574C99.3018 7.63574 100.578 8.79007 100.578 10.4061V92.1326C100.578 93.6332 99.4178 94.903 97.7938 94.903H37.3555C35.8475 94.903 34.5714 93.7487 34.5714 92.1326V10.4061C34.5714 8.9055 35.7315 7.63574 37.3555 7.63574H97.7938Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.578 16.1777V92.0171C100.578 93.5177 99.4178 94.7875 97.7938 94.7875H42.5757L37.7036 89.9393L92.5736 14.7925L97.3298 13.061L100.578 16.1777Z",
    fill: "#BCC4CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5618 13.9845C97.5618 13.5228 97.2138 13.061 96.6337 13.061H38.6316C38.1676 13.061 37.7036 13.4073 37.7036 13.9845V89.0159C37.7036 89.4776 38.0516 89.9393 38.6316 89.9393H96.5177C96.9818 89.9393 97.4458 89.593 97.4458 89.0159L97.5618 13.9845Z",
    fill: "#D9DFEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5618 13.9845C97.5618 13.5228 97.2138 13.061 96.6338 13.061H38.6316C38.1676 13.061 37.7036 13.4073 37.7036 13.9845C38.3996 43.8816 38.6316 77.7035 35.3835 86.4763L90.9495 85.6683C94.3137 70.4312 96.8658 43.0736 97.5618 13.9845Z",
    fill: "#EFF3FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2447_1879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.4454 13.1763C97.4454 13.1763 97.3294 17.6782 95.9373 46.4209C95.9373 46.6518 95.9373 46.7672 95.9373 46.9981C94.1972 75.1637 69.1403 81.0508 66.1242 81.3971C64.7322 81.5125 62.0641 81.7434 57.3079 81.7434C51.3917 81.9743 42.3433 82.0897 28.1908 82.2051C27.7268 82.2051 27.3788 81.7434 27.6108 81.2817C37.3551 61.7735 37.4711 13.2917 37.4711 13.2917L97.4454 13.1763Z",
    fill: "white"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8217 46.8828C94.1976 75.0484 69.0247 80.9355 66.0086 81.2818C64.6165 81.3972 61.9484 81.6281 57.1923 81.6281C69.7207 75.8565 76.449 65.4675 76.333 57.3872C82.3652 57.8489 92.8056 57.3872 95.8217 46.8828Z",
    fill: "#EAEEF9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6692 7.86623C81.6692 7.7508 81.6692 7.7508 81.6692 7.86623L81.0892 7.28907C81.0892 7.28907 80.7412 7.4045 80.6252 7.63537H71.5768C71.5768 7.4045 71.5768 7.28907 71.5768 7.0582C71.5768 5.21128 69.9528 3.59521 68.0967 3.59521C66.2406 3.59521 64.6166 5.21128 64.6166 7.0582C64.6166 7.28907 64.6166 7.4045 64.7326 7.51993H55.3362C54.8722 7.51993 54.4082 7.86623 54.4082 8.55883V11.5601C54.4082 13.8687 56.0323 15.2539 58.2363 15.2539H77.4931C79.8131 15.2539 81.7852 13.8687 81.7852 11.5601V8.4434C81.9012 8.21253 81.7852 7.98166 81.6692 7.86623Z",
    fill: "#1C3754"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3211 7.86645V10.8677C81.3211 11.0986 81.3211 11.214 81.3211 11.4449C80.9731 13.4072 79.3491 15.0233 77.261 15.0233H57.8883C55.8002 15.0233 54.1761 13.4072 53.8281 11.4449C53.8281 11.214 53.8281 11.0986 53.8281 10.8677V7.86645C53.8281 7.40471 54.1761 6.82755 54.7562 6.82755H64.2685C64.2685 6.59668 64.2685 6.48125 64.2685 6.36582C64.2685 4.51889 65.8926 2.90283 67.7486 2.90283C69.6047 2.90283 71.2288 4.51889 71.2288 6.36582C71.2288 6.59668 71.2288 6.71212 71.2288 6.82755H80.7411C80.9731 6.94298 81.3211 7.28928 81.3211 7.86645Z",
    fill: "url(#paint0_linear_2447_1879)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5166 7.98163C68.4447 7.98163 69.1407 7.28903 69.1407 6.36557C69.1407 5.44211 68.4447 4.74951 67.5166 4.74951C66.5886 4.74951 65.8926 5.44211 65.8926 6.36557C65.8926 7.28903 66.7046 7.98163 67.5166 7.98163Z",
    fill: "#EAEEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2051 11.4448C80.8571 13.4072 79.2331 15.0232 77.145 15.0232H57.8883C55.8002 15.0232 54.1761 13.4072 53.8281 11.4448H81.2051Z",
    fill: "#9AA1B2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9722 46.5365C53.8282 46.5365 55.2203 45.0359 55.2203 43.3044C55.2203 41.4575 53.7122 40.0723 51.9722 40.0723C50.1161 40.0723 48.724 41.5729 48.724 43.3044C48.608 45.0359 50.1161 46.5365 51.9722 46.5365Z",
    fill: "#989FB0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7249 46.4208C79.581 46.4208 80.973 44.9202 80.973 43.1887C80.973 41.3417 79.465 39.9565 77.7249 39.9565C75.9849 39.9565 74.4768 41.4572 74.4768 43.1887C74.4768 44.9202 75.8689 46.4208 77.7249 46.4208Z",
    fill: "#989FB0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9808 49.999H61.7166V51.4997H67.9808V49.999Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M130.507 13.5225C133.059 25.5275 132.711 38.2251 129.231 49.9993C128.419 52.4233 127.607 55.0783 125.867 56.9252C123.431 59.811 119.023 61.0808 115.426 60.1573C111.714 59.2339 108.698 56.0018 108.002 52.077C107.422 49.653 108.234 46.7671 110.322 45.2665C112.526 43.8813 115.658 44.2276 117.514 45.9591C119.603 47.6906 120.415 50.3456 120.299 52.8851C120.183 55.4246 119.255 57.9641 117.979 60.1573C114.15 67.3142 107.19 72.9704 99.1858 75.5099C93.2696 77.3569 86.8894 77.3568 80.9731 75.7408",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M135.379 10.0598C135.031 11.3296 133.639 11.7913 132.247 10.9833C130.739 10.2907 129.695 9.71354 129.927 8.55921C130.275 7.40488 131.667 7.28945 133.291 7.17402C135.263 6.94315 135.611 8.79008 135.379 10.0598Z",
    fill: "#DAE2EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.127 11.2142C124.707 12.253 126.331 12.9456 127.491 11.9067C128.767 10.7524 129.811 9.94439 129.231 8.79006C128.651 7.75116 127.723 8.09746 125.751 8.32833C124.127 8.67463 123.431 10.0598 124.127 11.2142Z",
    fill: "#DAE2EB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.231 6.94297C130.043 6.82754 130.855 7.28927 131.087 7.98187C131.203 8.21273 131.319 8.55903 131.319 8.7899C131.551 10.406 130.971 11.7912 130.043 11.9066C128.999 12.1375 127.955 10.9831 127.839 9.48249C127.839 9.02076 127.839 8.7899 127.839 8.4436C127.955 7.63557 128.419 7.0584 129.231 6.94297C129.347 6.94297 129.231 6.94297 129.231 6.94297Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2447_1879",
    x: 5.53693,
    y: 2.17627,
    width: 113.908,
    height: 113.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2447_1879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2447_1879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2447_1879",
    x1: 53.8613,
    y1: 8.96456,
    x2: 81.3476,
    y2: 8.96456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHome);
export default __webpack_public_path__ + "static/media/no-home.bbbbaa878cd247008a290d2a18d7a511.svg";
export { ForwardRef as ReactComponent };